import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import { isAuthenticated } from "./services/auth";

import Logon from "./pages/Logon";
//import Dashboard from './pages/Dashboard';
import UserList from "./pages/User/List";
import UserCreate from "./pages/User/Create";
import UserViewEdit from "./pages/User/ViewEdit";
import StoreList from "./pages/Store/List";
import StoreViewEdit from "./pages/Store/ViewEdit";
import StoreCreate from "./pages/Store/Create";
import RoutesList from "./pages/Route/List";
import RoutesViewEdit from "./pages/Route/ViewEdit";
import RoutesCreate from "./pages/Route/Create";
import ProductsList from "./pages/Product/List";
import ProductsViewEdit from "./pages/Product/ViewEdit";
import ProductsCreate from "./pages/Product/Create";
import Competitors from "./pages/Competitors/List";
import CompetitorsViewEdit from "./pages/Competitors/ViewEdit";
import CompetitorsCreate from "./pages/Competitors/Create";
import VisitsList from "./pages/Visit/List";
import VisitsView from "./pages/Visit/View";
import Map from "./pages/Visit/Map";
import PromoterList from "./pages/User/ListPromoters";
import LogsList from "./pages/Logs";

import Sidebar from "./components/Sidebar";

const PrivateRoute = ({ sidebar: Sidebar, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component sidebar={Sidebar} {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

export default function Routes() {
  const Sidebarr = ({ ...rest }) => {
    return <Sidebar {...rest} />;
  };

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Logon} />
        <PrivateRoute path="/map" sidebar={Sidebarr} component={Map} />
        {/*<PrivateRoute path="/dashboard" sidebar={Sidebarr} component={Dashboard} />*/}
        <PrivateRoute
          path="/users/new"
          exact
          sidebar={Sidebarr}
          component={UserCreate}
        />
        <PrivateRoute
          path="/users/:id"
          sidebar={Sidebarr}
          component={UserViewEdit}
        />
        <PrivateRoute path="/users" sidebar={Sidebarr} component={UserList} />
        <PrivateRoute
          path="/promoters"
          sidebar={Sidebarr}
          component={PromoterList}
        />
        <PrivateRoute
          path="/stores/new"
          exact
          sidebar={Sidebarr}
          component={StoreCreate}
        />
        <PrivateRoute
          path="/routes/new"
          exact
          sidebar={Sidebarr}
          component={RoutesCreate}
        />
        <PrivateRoute
          path="/stores/:id"
          sidebar={Sidebarr}
          component={StoreViewEdit}
        />
        <PrivateRoute path="/stores" sidebar={Sidebarr} component={StoreList} />
        <PrivateRoute
          path="/routes/:id"
          sidebar={Sidebarr}
          component={RoutesViewEdit}
        />
        <PrivateRoute
          path="/routes"
          sidebar={Sidebarr}
          component={RoutesList}
        />
        <PrivateRoute
          path="/products/new"
          exact
          sidebar={Sidebarr}
          component={ProductsCreate}
        />
        <PrivateRoute
          path="/products/:id"
          sidebar={Sidebarr}
          component={ProductsViewEdit}
        />
        <PrivateRoute
          path="/products"
          sidebar={Sidebarr}
          component={ProductsList}
        />
        <PrivateRoute
          path="/competitors/new"
          exact
          sidebar={Sidebarr}
          component={CompetitorsCreate}
        />
        <PrivateRoute
          path="/competitors/:id"
          sidebar={Sidebarr}
          component={CompetitorsViewEdit}
        />
        <PrivateRoute
          path="/competitors"
          sidebar={Sidebarr}
          component={Competitors}
        />
        <PrivateRoute
          path="/visits/:id"
          sidebar={Sidebarr}
          component={VisitsView}
        />
        <PrivateRoute
          path="/visits"
          sidebar={Sidebarr}
          component={VisitsList}
        />
        <PrivateRoute path="/logs" sidebar={Sidebarr} component={LogsList} />
        <Route path="*" component={() => <h1>Página não encontrada</h1>} />
      </Switch>
    </BrowserRouter>
  );
}
